// extracted by mini-css-extract-plugin
export var autoExpand = "_2e-8";
export var container = "_2e-7";
export var containerWidth = "_2e-5";
export var disabled = "_2e-2";
export var error = "_2e-3";
export var fullWidth = "_2e-6";
export var inputWrapper = "_2e-0";
export var small = "_2e-1";
export var textarea = "_2e-4";